@defer (when carousels$ | async) {
    @for (carousel of carousels$ | async; track carousel) {
        @if (carouselsChanges$ | async; as carouselsChanges) {
            @if (carouselsChanges[carousel.id]?.filteredItemsIds?.length) {
                <div [ngClass]="carousel?.titleKey" class="flex-column is-flex">
                    @switch (carousel?.view) {
                        @case ('carrusel') {
                            <related-products-carousel
                                [products]="carouselsChanges[carousel.id]?.productsLoaded"
                                [place]="place"
                                [carousel]="carousel"
                                [filteredItemsIds]="carouselsChanges[carousel.id]?.filteredItemsIds"
                                [baseProduct]="baseProducts?.[0]"
                                [category]="category$ | async"
                                [showQuickly]="showQuickly"
                                [isRtl]="isRtl$ | async"
                                [direction]="direction$ | async"
                                [eventFrom]="eventFrom"
                                [hidePriceText]="hidePriceText"
                                [slidesPerView]="slidesPerView"
                                [imageType]="carousel.imageType"
                            ></related-products-carousel>
                        }
                        @case ('grid') {
                            <related-products-grid
                                [products]="carouselsChanges[carousel.id]?.productsLoaded"
                                [place]="place"
                                [carousel]="carousel"
                                [filteredItemsIds]="carouselsChanges[carousel.id]?.filteredItemsIds"
                                [baseProduct]="baseProducts?.[0]"
                                [isRtl]="isRtl$ | async"
                                [category]="category$ | async"
                                [showQuickly]="showQuickly"
                                [eventFrom]="eventFrom"
                                [imageType]="carousel.imageType"
                            >
                            </related-products-grid>
                        }
                    }
                </div>
            }
        }
    }
} @placeholder (minimum 500ms) {
    @if (isPlaceholderEnabled) {
        <related-products-skeleton></related-products-skeleton>
    }
}
